import { z, zDecimalNullable } from '@harvestiq/zod';

/**
 * Schema for transforming AMS API response to database records
 * Only includes fields ending with *_Price from the API response
 */
export const drpAmsMonthlyActualPricesSchema = z.object({
  reportYear: z.number().int().min(2025),
  reportMonth: z.string(),
  weekEndingDate: z.string(),
  createdDate: z.string(),
  publishedDate: z.string(),
  narrative: z.string().nullable().optional(),
  officeName: z.string().nullable().optional(),
  officeCode: z.string().nullable().optional(),
  officeCity: z.string().nullable().optional(),
  officeState: z.string().nullable().optional(),
  marketLocationName: z.string().nullable().optional(),
  marketLocationCity: z.string().nullable().optional(),
  marketLocationState: z.string().nullable().optional(),
  marketType: z.string().nullable().optional(),
  marketTypeCategory: z.string().nullable().optional(),
  reportTitle: z.string().nullable().optional(),
  slugName: z.string().nullable().optional(),
  slugId: z.string().nullable().optional(),
  // Price fields - in camelCase to match application model and Kysely plugin
  class2Price: zDecimalNullable().optional(),
  class2ButterfatPrice: zDecimalNullable().optional(),
  advancedSkimMilkClass2Price: zDecimalNullable().optional(),
  class3Price: zDecimalNullable().optional(),
  class3SkimMilkPrice: zDecimalNullable().optional(),
  class4Price: zDecimalNullable().optional(),
  class4SkimMilkPrice: zDecimalNullable().optional(),
  butterfatPrice: zDecimalNullable().optional(),
  nonfatSolidsPrice: zDecimalNullable().optional(),
  proteinPrice: zDecimalNullable().optional(),
  otherSolidsPrice: zDecimalNullable().optional(),
  butterMonthlyAvgPrice: zDecimalNullable().optional(),
  nfdmMonthlyAvgPrice: zDecimalNullable().optional(),
  cheeseMonthlyAvgPrice: zDecimalNullable().optional(),
  cheeseMonthly40pPrice: zDecimalNullable().optional(),
  cheeseMonthly500pPrice: zDecimalNullable().optional(),
  wheyMonthlyAvgPrice: zDecimalNullable().optional(),
  somaticCellAdjustmentRate: zDecimalNullable().optional(),
});

export type DrpAmsMonthlyActualPrices = z.infer<
  typeof drpAmsMonthlyActualPricesSchema
>;
